<template>
    <glass-panel
        radius="lg"
        class="pa-8 d-flex flex-column"
        style="gap:24px;height:100%"
    >
        <div>
            <h3 class="card-title-strong mb-6">{{ title }}</h3>
            <div class="support-panel__cta mb-4">
                <p class="body-sm mb-4">{{ description }}</p>
                <v-btn
                    block
                    color="primary"
                    large
                    elevation="0"
                    @click="$emit('action')"
                >
                    <v-icon
                        left
                        size="18"
                    >
                        {{ actionIcon }}
                    </v-icon>
                    {{ actionLabel }}
                </v-btn>
            </div>
        </div>
    </glass-panel>
</template>

<script>
export default {
    name: 'SupportPanel',
    props: {
        title: { type: String, default: 'Suporte & consultoria' },
        description: { type: String, default: 'Precisa de ajuda com sua estratégia digital? Nossos especialistas estão prontos.' },
        actionLabel: { type: String, default: 'Falar com suporte' },
        actionIcon: { type: String, default: 'mdi-chat-outline' },
    },
}
</script>

<style scoped>
.support-panel__cta {
    background: rgba(112, 42, 225, 0.04);
    border: 1px solid rgba(112, 42, 225, 0.1);
    border-radius: var(--radius-sm);
    padding: 16px;
}
</style>
